<template>
  <section class="number-range-picker-container">
    <b-dropdown multiple aria-role="list" class="number-range-picker">
      <template #trigger>
        <b-button
          type="is-normal"
          icon-right="menu-down"
          class="number-range-picker-dropdown"
        >
          <span v-if="formData.option2"
            >{{ formData.option1 }} to {{ formData.option2 }}</span
          >
          <span v-else>Select {{ formData.option2 }}</span>
        </b-button>
      </template>
      <div class="columns column">
        <b-input
          v-model="formData.option1"
          type="number"
          min="0"
          class="input-padding"
          @input="validateNumber"
          @keyup.native.enter="searchData"
        ></b-input>
        <span>to</span>
        <b-input
          v-model="formData.option2"
          type="number"
          min="0"
          class="input-padding"
          @input="validateNumber"
          @keyup.native.enter="searchData"
        ></b-input>
      </div>
    </b-dropdown>
  </section>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    clearFilter: {
      type: Boolean
    }
  },
  methods: {
    validateNumber() {
      if (this.formData.option1 === "") {
        this.formData.option1 = "0";
      }
      this.$emit("assignNumberRangeValue", this.formData, this.id);
    },
    searchData() {
      this.$emit("searchData", this.formData);
    }
  },
  watch: {
    clearFilter() {
      if (!this.initialValue) {
        this.formData.option1 = "";
        this.formData.option2 = "";
      } else {
        this.initialValue = false;
      }
    }
  },
  data() {
    return {
      formData: {
        option1: "",
        option2: ""
      },
      initialValue: true
    };
  }
};
</script>

<style scoped>
.number-range-picker-container {
  margin-bottom: 0 !important;
}
.input-padding {
  padding: 0 10px; /* Adjust the padding as needed */
}
</style>
